import { health } from '@/api';
import sessionManager from '@/store/modules/session/sessionManager';
import * as types from './mutationTypes';

export default {
  async loadModules({ dispatch }) {
    const getClientContext = dispatch('clientContext/getAll');
    // TODO: Maybe move this inside of the AppSideNav component if the
    // data is not global.
    const getActivatedModules = dispatch('activatedCEModules/getAll');

    return Promise.all([getClientContext, getActivatedModules]).catch((err) => Promise.reject(err));
  },

  async appInitialise({ dispatch, commit }, version) {
    commit(types.APP_SET_VERSION, version);

    // TODO: can we move this to session.action - initialize after 'saveOriginalAdminRole'?
    // when app is initialised NOT due to new login, we want to maintain draftMode state
    dispatch('authorisation/saveDraftMode', undefined, { root: true });

    await dispatch('session/initialize');

    commit(types.APP_SET_INITIALISED);

    const getQuicklinksApiVersion = health.getApiVersion();
    const getContentEngineApiVersion = health.getContenEngineVersion();

    const responses = await Promise.all([getQuicklinksApiVersion, getContentEngineApiVersion]);

    if (typeof responses[0].data.version !== 'undefined') {
      commit(types.APP_SET_API_VERSION, responses[0].data.version);
    }

    if (typeof responses[1].data.version !== 'undefined') {
      commit(types.APP_SET_CE_VERSION, responses[1].data.version);
    }
  },

  async initAppName({ commit, rootGetters }, applicationName) {
    const appNameLocalStorage = sessionManager.getAppNameFromStorage();
    if (appNameLocalStorage) {
      commit(types.APP_SET_APP_NAME, appNameLocalStorage);
      return appNameLocalStorage;
    }

    if (!rootGetters['session/isAuthenticated']()) {
      sessionManager.clearToken();
    }

    let appName = applicationName;
    if (!applicationName) {
      appName = await sessionManager.getAppName();
    }

    sessionManager.saveAppName(appName);
    commit(types.APP_SET_APP_NAME, appName);
    return appName;
  },

  async getAppNameFromHost() {
    return sessionManager.getAppName();
  }
};
